export default "__VITE_ASSET__BEQVheUL__"